module.exports = __webpack_public_path__ + "static/img/Mockup.a6d43acd.png";